import React from 'react';
import { ForgotPasswordForm } from '../../components/auth';
import { AuthLayout } from './LoginPage';

export const ForgotPasswordPage: React.FC = () => (
  <AuthLayout>
    <ForgotPasswordForm />
  </AuthLayout>
);
